// import UUID from '../config/partnerUUID';
import store from './store';//
let appVersion = '2095';
let _GITV = window.gitv;
// let partnerCode = 'AAA';
let partnerCode = 'JS_CMCC_CP';
let tokenCode = '47CD3714F323CC9BCA3165CC164DAB746C77B14CECFF79E7DEC38B2C12C47EC65F06D8B84CD16C4AA901AF7D5ACADD5AF16139B61479A15AB2CF7C2F2A37B7F541553AFBBF36A3FC09E37031928275CDD7D64DEB2632F3AFB45404E31014C3F69EC594C8FAEB169C372EDE9B51ED63CBDFE492BA67E993B211DE3764D5670E91A966F0C91B46DA7413CD27D9D20135376C4229E83EF15F621EA5833D5C4E6173E40A8C09E38C2CABC1F7EBF323A923AA';
let macCode = '54:c5:7a:fd:3d:34';
// let partnerUUID = UUID[partnerCode];
let userId = '00000001';
let appLs = 0;
let hmci = "";
let hmcn = "";
let region = "";
let ut = "";
let newuser = "";
let hm = "";
let stb = "";
let userToken = "", epgServer = '', appSI = '', userSTBID = '';
//urlPath：政策默认请求的url地址，和服务端商议之前，不可删除，不可修改
let urlPath='https://text-page.api.gitv.tv/policyApi';
var version = {
  "list":[
    {
      "version":"1.0.29",
      "versionCode":"1029",
      "changeTime":"20240613102348"
    }
  ]
};
var H5V = version.list[0].version;
if (store.getUrlParam('partnerCode')) {
  partnerCode = store.getUrlParam('partnerCode');
}
// 获取盒子信息
if(_GITV){
    partnerCode = _GITV.getPartnerCode();
    tokenCode = _GITV.getToken();
    appVersion = _GITV.getVersion();
    macCode = _GITV.getMac();
    // partnerUUID = UUID[partnerCode];
    userId = _GITV.getUserId();
    hmci = _GITV.getMarketHardwareChannelId && _GITV.getMarketHardwareChannelId();
    hmcn = _GITV.getMarketHardwareChannelName && _GITV.getMarketHardwareChannelName();
    region = _GITV.getRegion && _GITV.getRegion();
    ut = _GITV.getUserType && _GITV.getUserType();
    newuser = _GITV.getNewUser && _GITV.getNewUser();
    stb = _GITV.getSerialNumber && _GITV.getSerialNumber();
    hm = _GITV.getBuildModel && _GITV.getBuildModel()
} else if(window._APP){
  partnerCode = window._APP.getPartnerCode();
  macCode = window._APP.getMac();
  tokenCode = window._APP.getToken();
  userToken = window._APP.getUserToken();
  userId = window._APP.getUserId() || macCode;
  userSTBID = window._APP.getStbID() || "";
  appVersion = window._APP.getVersion();
  epgServer = window._APP.getEpgServer();
  appSI = window._APP.getDataSource() || '37';
};

if (partnerCode == 'HM_HEALTH') {
  urlPath = 'https://text-page-health.increase.gitv.tv/jiankang/policyApi';
} else if (partnerCode == 'HBJD' || partnerCode == 'HBYD' || partnerCode == 'HBYD_KIDS' || partnerCode == 'HBYD_GVP' || partnerCode == 'HBYD_TYSS') {
  urlPath = 'https://hebei-text-page.api.gitv.tv/hebei/policyApi';
}
// console.log("UUID ------:" + partnerUUID);
console.log("partnerCode---------"+partnerCode);
// 处理当前时间
let getTime = () => {
    let d = new Date();
    let yyyy = d.getFullYear();
    let mm = d.getMonth() + 1;
    let dd = d.getDate();
    let hh = d.getHours();
    let mi = d.getMinutes();
    let ss = d.getSeconds();
    mm = mm < 10 ? '0' + mm : mm.toString();
    dd = dd < 10 ? '0' + dd : dd.toString();
    hh = hh < 10 ? '0' + hh : hh.toString();
    mi = mi < 10 ? '0' + mi : mi.toString();
    ss = ss < 10 ? '0' + ss : ss.toString();

    let curDate = yyyy + mm + dd + hh + mi + ss;
    return  curDate;
    // console.log(curDate);

}


export default {

    getPBOpt(ot){
        ++appLs;
        let date = getTime();
        const reqUrl = `https://pb-h5.gitv.tv/game_pb/g?A=814&PV=5.8.17&TS=${date}&MC=${macCode}&userId=${userId}&ls=${appLs}&ot=${ot}&V=${appVersion}&STBID=${stb || '_'}&HM=${hm}&P=${partnerCode || '_'}&hmci=${hmci}&hmcn=${hmcn}&region=${region}&ut=${ut}&newuser=${newuser}&h5v=${H5V}`;
        console.log(`reqUrl_PBOpt---${reqUrl}`);
        return reqUrl;
    },
    //获取内容html
    getContent(){
      const reqUrl = `${urlPath}/getPolicyPage/?policyPageId=${store.getUrlParam('screenId')}`;
      console.log("getContent----"+reqUrl)
      return reqUrl;
    },
}




// WEBPACK FOOTER //
// ./src/commonjs/urlConfiger.js